/**
 * «У категории — её темы» (#845 §5, §2.1): обращение «темы строк → категории
 * звонка». Считается на клиенте из `rows[].categories`; тема и категория —
 * разные измерения, поэтому здесь они лишь перечислены рядом, без долей.
 */
import { useTranslation } from 'react-i18next';
import type { VoiceThemeRow } from '@aica/api-types/schemas';
import { categoryThemes } from './voice-themes-view-model';
import { VoiceTopList } from './VoiceTopList';

export function VoiceThemeCategories({
  rows,
  limit,
}: {
  rows: readonly VoiceThemeRow[];
  /** The first categories only, then «Show all N» (#2060). */
  limit?: number;
}) {
  const { t } = useTranslation(['dashboard', 'records']);
  const categories = categoryThemes(rows);
  if (categories.length === 0) return null;
  return (
    <section className="mt-4 space-y-2" data-testid="voice-theme-categories">
      <h4 className="text-sm font-medium text-fg">
        {t('voicePage.themes.analytics.categoriesTitle')}
      </h4>
      <VoiceTopList
        list="ul"
        gap="space-y-1"
        rows={categories}
        limit={limit}
        rowKey={(entry) => entry.category}
        renderRow={(entry) => (
          <li key={entry.category} className="text-xs text-fg-muted">
            <span className="font-medium text-fg">
              {t(`records:records.callCategory.${entry.category}`)}
            </span>
            {': '}
            {entry.themes.map((theme) => `${theme.name} ${theme.calls}`).join(' · ')}
          </li>
        )}
      />
    </section>
  );
}
